/** Formats an event's date, or a start–end range when endDateISO is set.
 *  A same-day range collapses to one date with both times; a multi-day
 *  range shows both full dates. withTime controls whether times are
 *  included at all (event cards/table rows usually don't need them). */
export function formatEventDate(dateISO: string, endDateISO?: string, opts?: { withTime?: boolean }): string {
  const withTime = opts?.withTime ?? false;
  const start = new Date(dateISO);
  const end = endDateISO ? new Date(endDateISO) : null;

  const dateFmt: Intl.DateTimeFormatOptions = { weekday: "short", month: "short", day: "numeric", year: "numeric" };
  const timeFmt: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "2-digit" };

  const startDateStr = start.toLocaleDateString(undefined, dateFmt);
  const startTimeStr = start.toLocaleTimeString(undefined, timeFmt);

  if (!end || Number.isNaN(end.getTime())) {
    return withTime ? `${startDateStr}, ${startTimeStr}` : startDateStr;
  }

  const sameDay = start.toDateString() === end.toDateString();
  const endDateStr = end.toLocaleDateString(undefined, dateFmt);
  const endTimeStr = end.toLocaleTimeString(undefined, timeFmt);

  if (sameDay) {
    return withTime ? `${startDateStr}, ${startTimeStr} – ${endTimeStr}` : startDateStr;
  }
  return withTime ? `${startDateStr}, ${startTimeStr} – ${endDateStr}, ${endTimeStr}` : `${startDateStr} – ${endDateStr}`;
}
